"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
exports.isVideoClientError = isVideoClientError;
var ErrorCode;
(function (ErrorCode) {
    /**
     * The browser does not support H264 codec.
     */
    ErrorCode["H264NotSupported"] = "h264-not-supported";
    /**
     * No backend endpoints or joinUrl were provided.
     */
    ErrorCode["NoBackendEndpoints"] = "no-backend-endpoints";
    /**
     * No players are available.
     */
    ErrorCode["NoPlayersAvailable"] = "no-players-available";
    /**
     * No userId provided.
     */
    ErrorCode["NoUserId"] = "no-userId";
    /**
     * Unable to join the call by unknown reason.
     */
    ErrorCode["UnableJoinCall"] = "unable-join-call";
    /**
     * Unable to change bitrate by some reason for specific consumer.
     */
    ErrorCode["UnableChangeBitrate"] = "unable-change-bitrate";
    /**
     * Unable to switch to specific quality.
     */
    ErrorCode["UnableSwitchQuality"] = "unable-switch-quality";
    /**
     * MediaStream is not supported by the browser.
     */
    ErrorCode["MediaStreamNotSupported"] = "media-stream-not-supported";
    /**
     * MediaDevice is not supported by the browser.
     */
    ErrorCode["MediaDeviceNotSupported"] = "media-device-not-supported";
    /**
     * The consumer was received from the server, but the player was not able to play it.
     */
    ErrorCode["ConsumerNotCreated"] = "consumer-not-created";
    /**
     * Network error.
     */
    ErrorCode["NetworkError"] = "network-error";
    /**
     * Manifest wa not loaded due to some reason.
     */
    ErrorCode["ManifestNotLoaded"] = "manifest-not-loaded";
    /**
     * The player was not able to load the stream.
     */
    ErrorCode["PlayerLoadingFailed"] = "player-loading-failed";
    /**
     * Manifest is not valid.
     */
    ErrorCode["BadManifest"] = "bad-manifest";
    /**
     * Audio/video device not found or not available.
     */
    ErrorCode["MediaDeviceNotAvailable"] = "media-device-not-available";
    /**
     * MediaController has not been initialized yet.
     */
    ErrorCode["MediaControllerNotInitialized"] = "media-controller-not-initialized";
    /**
     * MediaDevice has not been changed due to error. See inner error for details.
     */
    ErrorCode["MediaDeviceChangingFailed"] = "media-device-changing-failed";
    /**
     * Attempt to start preparing media stream while another stream is preparing.
     */
    ErrorCode["MediaStreamPreparingConflict"] = "media-stream-preparing-conflict";
    /**
     * MediaTrack has ended unexpectedly.
     */
    ErrorCode["MediaTrackEnded"] = "media-track-ended";
    /**
     * Constraints are not applied due to some error.
     */
    ErrorCode["ApplyingConstraintsFailed"] = "constraints-not-applied";
    /**
     * The error is not handled by the VideoClient.
     */
    ErrorCode["NativeError"] = "native-error";
    /**
     * The given source is not supported by the player.
     */
    ErrorCode["PlayerSourceNotSupported"] = "player-source-not-supported";
    /**
     * Unable to get available resolutions for selected device.
     */
    ErrorCode["UpdateResolutionsFailed"] = "update-resolutions-failed";
    /**
     * An error occurred while disposing an object.
     */
    ErrorCode["DisposingError"] = "disposing-error";
    /**
     * Internal check failed. This is a VideoClient bug.
     */
    ErrorCode["AssertionError"] = "assertion-error";
    /**
     * The stream with specified name already exists.
     */
    ErrorCode["StreamNameAlreadyExists"] = "stream-name-already-exists";
    /**
     * The stream with specified name does not exist.
     */
    ErrorCode["StreamNotFound"] = "stream-not-found";
    /**
     * Unable to broadcast video due to some error.
     */
    ErrorCode["BroadcastVideoFailed"] = "broadcast-video-failed";
    /**
     * Unable to broadcast audio due to some error.
     */
    ErrorCode["BroadcastAudioFailed"] = "broadcast-video-failed";
    /**
     * SFU hits the limit of concurrent connections per peer.
     */
    ErrorCode["SFUBusy"] = "sfu-busy";
    /**
     * Websocket is in transit state (connecting/disconnecting).
     */
    ErrorCode["WebSocketInTransit"] = "websocket-in-transit";
    /**
     * Websocket is not connected.
     */
    ErrorCode["WebSocketNotConnected"] = "websocket-not-connected";
    ErrorCode["NotAllowed"] = "not-allowed";
    ErrorCode["BadInput"] = "bad-input";
    ErrorCode["CallError"] = "call-error";
    ErrorCode["CapturableStreamError"] = "capturable-stream-error";
    ErrorCode["Constraints"] = "constraints";
    ErrorCode["ConsumerNotFound"] = "consumer-not-foud";
    ErrorCode["DeviceInUse"] = "device-in-use";
    ErrorCode["DeviceNotFound"] = "device-not-found";
    ErrorCode["DisableAudioError"] = "disable-audio-error";
    ErrorCode["DisableVideoError"] = "disable-video-error";
    ErrorCode["DisposedObject"] = "disposed-object";
    ErrorCode["DriverNotSupported"] = "driver-not-supported";
    ErrorCode["ElementRequired"] = "element-required";
    ErrorCode["EmbedSWFFailed"] = "embedding-flash-swf-failed";
    ErrorCode["EnableAudioError"] = "enable-audio-error";
    ErrorCode["EnableVideoError"] = "enable-video-error";
    ErrorCode["EnumeratingDevices"] = "enumerating-devices-error";
    ErrorCode["GetUserMediaFailed"] = "get-user-media-failed";
    ErrorCode["HandleHlsJsError"] = "handle-hlsjs-error";
    ErrorCode["HlsjsNotLoaded"] = "hlsjs-not-loaded";
    ErrorCode["InternalCallError"] = "internal-call-error";
    ErrorCode["InternalError"] = "internal-error";
    ErrorCode["InvalidBitrate"] = "invalid-bitrate";
    ErrorCode["InvalidControls"] = "invalid-controls-parent";
    ErrorCode["InvalidElement"] = "invalid-element";
    ErrorCode["InvalidMediaURL"] = "invalid-media-url";
    ErrorCode["InvalidPopoutURL"] = "invalid-popout-url";
    ErrorCode["JoinCallError"] = "join-call-error";
    ErrorCode["JoinCallRejected"] = "join-call-rejected";
    ErrorCode["LayerNotFound"] = "layer-not-found";
    ErrorCode["ManifestError"] = "manifest-error";
    ErrorCode["ManifestForbidden"] = "manifest-forbidden";
    ErrorCode["ManifestInternalError"] = "manifest-internal-error";
    ErrorCode["ManifestNotFound"] = "manifest-not-found";
    ErrorCode["ManifestUnauthorized"] = "manifest-unauthorized";
    ErrorCode["ManifestUnexpectedResponse"] = "manifest-unexpected-response";
    ErrorCode["MediaError"] = "media-error";
    ErrorCode["MediaRecorderError"] = "media-recorder-error";
    ErrorCode["MediasoupSetupError"] = "mediasoup-setup-error";
    ErrorCode["MeowDriverError"] = "meow-driver-error";
    ErrorCode["Mp4BufferError"] = "mp4-buffer-error";
    ErrorCode["NoDrivers"] = "no-valid-drivers";
    ErrorCode["NotInitialized"] = "not-initialized";
    ErrorCode["NotSupported"] = "not-supported";
    ErrorCode["Permission"] = "permission-error";
    ErrorCode["PlaybackError"] = "playback-error";
    ErrorCode["PlayingIssue"] = "playing-issue";
    ErrorCode["RetrievingMediaStreamError"] = "retrieving-media-stream-error";
    ErrorCode["ResolutionsInUse"] = "resolutions-in-use-error";
    ErrorCode["SFUConsumerClosedEvent"] = "sfu-consumer-closed-event";
    ErrorCode["SFUConsumerLayersChangedEvent"] = "sfu-consumer-layers-changed-event";
    ErrorCode["SFUConsumerPausedEvent"] = "sfu-consumer-paused-event";
    ErrorCode["SFUConsumerResumedEvent"] = "sfu-consumer-resumed-event";
    ErrorCode["SFUConsumerScoreEvent"] = "sfu-consumer-score-event";
    ErrorCode["SFUConsumerSourcesEvent"] = "sfu-consumer-sources-event";
    ErrorCode["SFUNewConsumerEvent"] = "sfu-new-consumer-event";
    ErrorCode["SFUNewPeersEvent"] = "sfu-new-peers-event";
    ErrorCode["SFUPeerClosedEvent"] = "sfu-peer-closed-event";
    ErrorCode["SFUProducerClosedEvent"] = "sfu-producer-closed-event";
    ErrorCode["SFUProducerPausedEvent"] = "sfu-producer-paused-event";
    ErrorCode["SFUProducerResumedEvent"] = "sfu-producer-resumed-event";
    ErrorCode["SFUSwitchConsumerTrackEvent"] = "sfu-switch-consumer-track-event";
    ErrorCode["SimulcastDisabled"] = "simulcast-disabled";
    ErrorCode["StartBroadcastError"] = "start-broadcast-error";
    ErrorCode["StreamExists"] = "stream-exists";
    ErrorCode["TrackEnded"] = "track-ended";
    ErrorCode["TransportStateError"] = "transport-state-error";
    ErrorCode["UnknownDriver"] = "unknown-driver";
    ErrorCode["UnknownError"] = "unknown-error";
    ErrorCode["UnrecognizedDriver"] = "unrecognized-driver";
    ErrorCode["UpdateBroadcastError"] = "start-broadcast-error";
    ErrorCode["UpdateMSCError"] = "update-msc-error";
    ErrorCode["UserRequired"] = "user-required";
    ErrorCode["ValidationError"] = "validation-error";
    ErrorCode["WSNetworkError"] = "websocket-network-error";
    ErrorCode["WSRequestError"] = "ws-request-error";
    /**
     * VDC doesn't support IE.
     */
    ErrorCode["IENotSupported"] = "ie-not-supported";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
function isVideoClientError(error) {
    return (error === null || error === void 0 ? void 0 : error.code) && Object.values(ErrorCode).includes(error.code);
}
//# sourceMappingURL=error.js.map